import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { FaFilePdf, FaBrain, FaUserMd } from "react-icons/fa";

const ParentAssessmentsCard = ({ user }) => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const fetchAssessments = async () => {
      setLoading(true);
      try {
        const q = collection(db, "users", user.uid, "assessments");
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setAssessments(data);
      } catch (error) {
        setAssessments([]);
      }
      setLoading(false);
    };
    fetchAssessments();
  }, [user]);

  return (
    <div className="my-8 max-w-4xl mx-auto bg-gradient-to-b from-indigo-50 to-white rounded-2xl shadow-lg p-8 border border-gray-300">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-indigo-800 flex items-center gap-2">
          <FaBrain className="inline-block text-indigo-500" /> My Assessments
        </h2>
        <span className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full font-semibold">
          {assessments.length} total
        </span>
      </div>
      <div className="mb-4">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded flex items-center gap-2">
          <span className="text-lg">📣</span>
          <span className="text-sm text-yellow-900 font-medium">
            Want deeper support? Connect with top-rated experts near you!
          </span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-indigo-200">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Assessment Name</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Child Name</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Age</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Date</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Score</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">PDF</th>
              <th className="px-4 py-2 text-left text-base font-bold text-indigo-700 bg-indigo-50">Expert</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7" className="py-6 text-center text-gray-400">Loading...</td></tr>
            ) : assessments.length === 0 ? (
              <tr><td colSpan="7" className="py-6 text-center text-gray-400">No assessments found.</td></tr>
            ) : (
              assessments.map((a) => (
                <tr key={a.id} className="hover:bg-indigo-100 border-b border-indigo-100 transition">
                  <td className="px-4 py-2 font-semibold text-indigo-900">{a.assessmentName || "M-CHAT-R/F"}</td>
                  <td className="px-4 py-2">{a.childName || "-"}</td>
                  <td className="px-4 py-2">{a.childAge || "-"}</td>
                  <td className="px-4 py-2">{a.timestamp ? new Date(a.timestamp.seconds * 1000).toLocaleDateString() : "-"}</td>
                  <td className="px-4 py-2">{typeof a.score === 'number' ? a.score : "-"}</td>
                  <td className="px-4 py-2">
                    {a.pdfUrl ? (
                      <a href={a.pdfUrl} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900 flex items-center gap-1 font-semibold"><FaFilePdf className="inline-block text-lg" /> PDF</a>
                    ) : (
                      <span className="text-gray-400 flex items-center gap-1"><FaFilePdf className="inline-block text-lg" /> N/A</span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    <button onClick={() => alert('Expert match coming soon!')} className="bg-green-100 hover:bg-green-200 text-green-800 px-3 py-1 rounded flex items-center gap-1 font-semibold"><FaUserMd className="inline-block text-lg" /> Consult</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ParentAssessmentsCard;
